<template>
  <v-form ref="categoryEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'category-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1 v-if="$route.name == 'subcategory-create' || $route.name == 'subcategory-edit'">
          {{this.subId ? 'Редактирование подкатегории' : 'Создание подкатегории'}}
        </h1>
        <h1 v-else>
          {{this.id ? 'Редактирование категории' : 'Создание категории'}}
        </h1>
      </v-col>
      <v-col>
        <v-tabs v-model="tab" >
          <v-tab>Описание</v-tab>
          <v-tab>SEO</v-tab>
          <v-tab :disabled="!this.id" v-show="!subId && $route.name != 'subcategory-create'">Подкатегории</v-tab>
          <v-tab :disabled="!sortCategoryId">Теги</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="pt-8">
          <v-tab-item>
            <v-row>
              <v-col  cols="12" sm="5" md="4" xl="3">
                <v-tabs v-model="tabLang">
                  <v-tab>RU</v-tab>
                  <v-tab>UA</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabLang">
                  <v-tab-item :eagerм="true">
                    <v-row>
                      <v-col>
                        <v-text-field
                                v-model="category.name"
                                label="Название"
                                :rules="[rules.required]"
                                required
                                outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item :eager="true">
                    <v-row>
                      <v-col>
                        <v-text-field
                                v-model="category.name_ua"
                                label="Название"
                                :rules="[rules.required]"
                                required
                                outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
                <div class="mb-8" v-if="listImage">
                  <v-img :src="previewImage(listImage)" width="100" height="100">
                    <template v-slot:placeholder>
                      <div class="image-placeholder"></div>
                    </template>
                  </v-img>
                </div>
                <div v-else-if="category.svg" class="mb-8 category-svg-big" style="width: 100px; height: 100px;" v-html="category.svg">
                </div>

                <v-file-input v-if="$route.name != 'subcategory-create' && $route.name != 'subcategory-edit'"
                              label="Картинка в список блюд"
                              prepend-icon=""
                              outlined
                              accept="image/svg+xml"
                              placeholder="90x90.svg"
                              class="cursor-pointer"
                              append-icon="mdi-attachment"
                              v-model="listImage">
                </v-file-input>
                <v-file-input v-else
                              label="Картинка в список блюд"
                              prepend-icon=""
                              outlined
                              accept="image/jpeg,image/png"
                              class="cursor-pointer"
                              placeholder="529x144.jpg"
                              append-icon="mdi-attachment"
                              v-model="listImage">
                </v-file-input>
                <div class="mb-8" v-if="mobileImage">
                  <v-img :src="previewMobileImage(mobileImage)" width="100" height="100">
                    <template v-slot:placeholder>
                      <div class="image-placeholder"></div>
                    </template>
                  </v-img>
                </div>

                <v-file-input
                              label="Картинка в список блюд для приложения"
                              prepend-icon=""
                              outlined
                              accept="image/jpeg,image/png"
                              placeholder="256x256.png"
                              class="cursor-pointer"
                              append-icon="mdi-attachment"
                              v-model="mobileImage">
                </v-file-input>
                <v-checkbox
                    v-model="category.is_disabled"
                    label="Выключить категорию"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-btn v-if="subId || (id && $route.name == 'category-edit')" @click="update">Сохранить</v-btn>
            <v-btn v-else @click="create">Создать</v-btn>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col  cols="12" sm="8" md="7" xl="6">
                <v-tabs v-model="tabLang">
                  <v-tab>RU</v-tab>
                  <v-tab>UA</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabLang">
                  <v-tab-item :eagerм="true">
                    <v-row>
                      <v-col>
                        <v-text-field
                            v-model="category.h1"
                            label="H1"
                            outlined
                        ></v-text-field>
                        <v-text-field
                                v-model="category.seo_title"
                                label="SEO Заголовок"
                                outlined
                        ></v-text-field>
                        <v-textarea
                                v-model="category.seo_description"
                                label="SEO Описание"
                                outlined
                        ></v-textarea>
                        <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i" v-model="category.seo_text" :init="{}" :toolbar="toolbar" :plugins="plugins"/>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item :eager="true">
                    <v-row>
                      <v-col>
                        <v-text-field
                            v-model="category.h1_ua"
                            label="H1"
                            outlined
                        ></v-text-field>
                        <v-text-field
                                v-model="category.seo_title_ua"
                                label="SEO Заголовок"
                                outlined
                        ></v-text-field>
                        <v-textarea
                                v-model="category.seo_description_ua"
                                label="SEO Описание"
                                outlined
                        ></v-textarea>
                        <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i" v-model="category.seo_text_ua" :init="{}" :toolbar="toolbar" :plugins="plugins"/>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <v-btn v-if="subId || (id && $route.name == 'category-edit')" @click="update">Сохранить</v-btn>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn @click="$router.push({ name: 'subcategory-create'})">Создать подкатегорию</v-btn>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-data-table
                        no-data-text="Нет категорий"
                        :headers="headers"
                        :items="category.children"
                        :header-props="{sortIcon: 'icon-custom-arrow'}"
                        :footer-props="footerProps"
                        :loading="loading"
                        :items-per-page="-1"
                        loading-text="Загрузка категорий... Подождите пожалуйста"
                >
                  <template v-slot:item.svg="{ item, index }">
                    <v-img v-if="item.main_image" width="110" height="32" :src="item.main_image.url"></v-img>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div class="text-right">
                      <v-menu offset-y left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                                  small
                                  class="mr-2"
                                  v-bind="attrs"
                                  v-on="on"
                          >
                            mdi-dots-vertical
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item @click.stop="$router.push({ name: 'subcategory-edit', params: { id: item.parent_group, subId: item.id } }); tab = 0">
                            <v-list-item-title>Редактировать</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="submitDialog = true; submitItem = item">
                            <v-list-item-title>Удалить</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" sm="8" md="7" xl="6">
                <v-data-table
                        no-data-text="Нет тегов"
                        :headers="tagsHeaders"
                        :items="tagsSort"
                        :header-props="{sortIcon: 'icon-custom-arrow'}"
                        :loading="loadingTags"
                        :items-per-page="-1"
                        hide-default-footer
                        loading-text="Загрузка тегов... Подождите пожалуйста"
                >
                  <template v-slot:body="props">
                    <draggable
                            :list="props.items"
                            @end="endDragTags(props.items)"
                            tag="tbody"
                            handle=".tags-sort__handle"
                    >
                      <tr v-for="(item, index) in props.items" :key="item.id">
                        <td class="text-center" style="width: 1%;">
                          <v-icon small class="page__grab-icon tags-sort__handle">mdi-arrow-all</v-icon>
                        </td>
                        <td style="width: 1%;">{{ index + 1 }}</td>
                        <td>
                          <div class="d-flex align-center">
                            <v-img v-if="item.image && item.image.url" class="mr-2 tags-sort__image" contain :src="item.image.url"></v-img>
                            {{ item.name }}
                          </div>
                        </td>
                      </tr>
                    </draggable>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
            right
            top
    >
      {{ snackbarText }}
    </v-snackbar>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import Vue from 'vue'
  import CategoryService from './../../api/CategoryService'
  import Editor from '@tinymce/tinymce-vue'
  import draggable from 'vuedraggable'
  export default {
    name: 'CategoryEdit',
    props: {
        id: {
            default: null,
        },
        subId: {
            default: null,
        }
    },
    components: {Editor, draggable},
    data: () => ({
      plugins: 'advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
      toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code ',
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      tab: '',
      submitDialog: false,
      submitItem: null,
      tabLang: '',
      valid: false,
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      category: {
          name: '',
          name_ua: '',
          h1: '',
          h1_ua: '',
      },
      listImage: null,
      mobileImage: null,
      loading: true,
      loadingButton: false,
      options: {},
      footerProps: {
          itemsPerPageText: 'Категорий на страницу',
          pageText: '{0}-{1} из {2}',
          itemsPerPageAllText: 'Все',
          itemsPerPageOptions: [-1]
      },
      headers: [
          {
              text: 'Категория',
              value: 'name'
          },
          {
              text: 'Количество',
              value: 'products_count',
          },
          {
              text: 'Изображение',
              value: 'svg',
              sortable: false
          },
          {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
      ],
      tagsSort: [],
      loadingTags: false,
      tagsHeaders: [
          {
              text: '',
              value: 'drag',
              sortable: false,
              width: '1%'
          },
          {
              text: '№',
              value: 'position',
              sortable: false,
              width: '1%'
          },
          {
              text: 'Тег',
              value: 'name',
              sortable: false
          },
      ],
    }),
    computed: {
      sortCategoryId() {
        if (this.subId) {
          return this.subId
        }
        if (this.$route.name === 'category-edit') {
          return this.id
        }
        return null
      }
    },
    mounted() {
        this.init()
    },
    watch: {
      "$route.path": "init"
    },
    methods: {
      submitDelete(item = null){
        if(item){
          this.removeCategory(item)
        } else {
          // this.massDelete()
        }
      },
      removeCategory(item){
        CategoryService.remove(item.id).then(response => {
          this.loading = true;
          this.init()
        });
      },
      init(){
        this.loading = true
        if(this.subId){
          CategoryService.get(this.subId)
            .then(response => {
              this.category = response.data;
              this.loading = false
              if(this.category.main_image){
                this.listImage = this.category.main_image;
                this.listImage.name = this.category.main_image.file
              }

              if(this.category.mobile_image){
                this.mobileImage = this.category.mobile_image;
                this.mobileImage.name = this.category.mobile_image.file
              }
            });
        } else if(this.id && this.$route.name != 'subcategory-create'){
          CategoryService.get(this.id)
            .then(response => {
              this.category = response.data;
              this.loading = false

              if(this.category.mobile_image){
                this.mobileImage = this.category.mobile_image;
                this.mobileImage.name = this.category.mobile_image.file
              }
            });
        } else if(this.$route.name == 'subcategory-create'){
          this.category = {
            name: '',
            name_ua: ''
          }
          this.tab = 0
        }
        this.initTagsSort()
      },
      initTagsSort(){
        if(!this.sortCategoryId){
          return
        }
        this.loadingTags = true
        Vue.axios.get('/products/get-current-tags', {params: {category: this.sortCategoryId, withChildren: true, type: 1}})
            .then(response => {
              this.tagsSort = response.data.map(tag => ({id: tag.id, name: tag.name, image: tag.image}))
              this.loadingTags = false
            })
      },
      endDragTags(items){
        this.tagsSort = items.map(tag => ({id: tag.id, name: tag.name, image: tag.image}))
        this.loadingButton = true;
        CategoryService.saveTagSort({
          category_id: this.sortCategoryId,
          sorts: items.map((tag, index) => ({tag_id: tag.id, sort_order: index + 1}))
        }).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Порядок тегов сохранен';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при сохранении порядка тегов';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false;
        })
      },
      validate(){
        this.$refs.categoryEditForm.validate()
        if(this.category.name == '' && this.category.name_ua != ''){
          this.tabLang = 0;
        }
        if(this.category.name != '' && this.category.name_ua == ''){
          this.tabLang = 1;
        }
      },
      previewImage(image) {
        if(this.listImage && this.listImage.url){
          return this.listImage.url
        }
        return URL.createObjectURL(image)
      },
      previewMobileImage(image) {
        if(this.mobileImage && this.mobileImage.url){
          return this.mobileImage.url
        }
        return URL.createObjectURL(image)
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        let formData = this.getData();

        CategoryService.update(this.category.id, formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Категория обновлена';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении категории';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false;
          this.loading = false;
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        CategoryService.create(formData).then(response => {
            if(this.$route.name == 'subcategory-create'){
                this.$router.push({ name: 'category-edit', params: { id: this.id } })
                this.tab = 1;
            } else {
                this.$router.push({ name: 'category-edit', params: { id: response.data.id } })
            }

          this.snackbar = true;
          this.snackbarText = 'Категория создана';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при создании категории';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false;
          this.loading = false;
        })
      },
      getData() {
        let formData = new FormData();

        formData.append('name_ua', this.category.name_ua);
        formData.append('name', this.category.name);
        formData.append('seo_title', this.category.seo_title);
        formData.append('h1', this.category.h1);
        formData.append('seo_description', this.category.seo_description);
        formData.append('seo_text', this.category.seo_text);
        formData.append('seo_title_ua', this.category.seo_title_ua);
        formData.append('h1_ua', this.category.h1_ua);
        formData.append('seo_description_ua', this.category.seo_description_ua);
        formData.append('seo_text_ua', this.category.seo_text_ua);
        formData.append('is_disabled', this.category.is_disabled ? 1 : 0);
        if(this.id && (this.subId || this.$route.name == 'subcategory-create')){
            formData.append('parent_group', this.id);
        }
        if(this.listImage && !this.listImage.url) {
            formData.append('listImage', this.listImage);
        }

        if(this.mobileImage && !this.mobileImage.url) {
          formData.append('mobileImage', this.mobileImage);
        }

        return formData;
      }
    },
  }
</script>

<style lang="scss">
  .category-svg-big{
    svg {
      width: 100px;
      height: 100px;
      path {
        stroke: #000
      }
    }
  }
  .tiptap-vuetify-editor{
    > div.v-card{
      height: 400px;
    }
  }
</style>

<style scoped lang="scss">

  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .product-images .v-image{
    max-height: 374px;
  }
  .modifier{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        text-align: center;
        margin-top: .83vw;
        .v-img{
          margin: 0 auto;
        }
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
  .sort-order-input{
    max-width: 120px;
  }
  .page__grab-icon{
    &:hover{
      cursor: move;
    }
  }
  .tags-sort__image.v-responsive{
    flex: 0 0 30px;
    width: 30px;
    height: 30px;
  }
</style>
